import api from './api';

// ============================================================
// Service da Recomendação de Compra (T2 / Camada 2).
// Espelha back/controller/recomendacao/Controller.RecomendacaoCompra.pas:
//   GET    /v1/recomendacao-compra
//   GET    /v1/recomendacao-compra/contar
//   POST   /v1/recomendacao-compra/executar
//   GET    /v1/recomendacao-compra/engine/status
//   GET    /v1/recomendacao-compra/config
//   PUT    /v1/recomendacao-compra/config
//   POST   /v1/recomendacao-compra/:id/em-pedido
//   POST   /v1/recomendacao-compra/:id/ignorar
//   POST   /v1/recomendacao-compra/:id/reabrir
// ============================================================

const BASE = '/v1/recomendacao-compra';

export const listarRecomendacoes = async (params = {}) => {
  const { data } = await api.get(BASE, { params });
  return data;
};

export const contarRecomendacoes = async () => {
  const { data } = await api.get(`${BASE}/contar`);
  return data;
};

export const marcarEmPedido = async (id, observacao = '') => {
  const { data } = await api.post(`${BASE}/${id}/em-pedido`, { observacao });
  return data;
};

export const marcarIgnorado = async (id, observacao = '') => {
  const { data } = await api.post(`${BASE}/${id}/ignorar`, { observacao });
  return data;
};

export const reabrir = async (id) => {
  const { data } = await api.post(`${BASE}/${id}/reabrir`);
  return data;
};

export const obterConfig = async () => {
  const { data } = await api.get(`${BASE}/config`);
  return data;
};

export const atualizarConfig = async (payload) => {
  const { data } = await api.put(`${BASE}/config`, payload);
  return data;
};

export const executarAgora = async () => {
  const { data } = await api.post(`${BASE}/executar`);
  return data;
};

export const obterEngineStatus = async () => {
  const { data } = await api.get(`${BASE}/engine/status`);
  return data;
};

export const SEVERIDADE_INFO = {
  critica: { label: 'Zerado', cor: '#dc2626' },
  alta: { label: 'Urgente', cor: '#ea580c' },
  media: { label: 'Atenção', cor: '#ca8a04' },
  baixa: { label: 'Sugestão', cor: '#2563eb' },
};

export const STATUS_INFO = {
  pendente: { label: 'Pendente', cor: 'primary' },
  em_pedido: { label: 'Em pedido', cor: 'success' },
  ignorado: { label: 'Ignorado', cor: 'secondary' },
  concluido: { label: 'Concluído', cor: 'dark' },
};

export const ABC_INFO = {
  A: {
    label: 'A',
    cor: '#7B176E',
    descricao: 'Top 80% do faturamento — mais críticos',
  },
  B: { label: 'B', cor: '#9b4d96', descricao: 'Próximos 15%' },
  C: { label: 'C', cor: '#b19cd9', descricao: 'Últimos 5%' },
};

const recomendacaoService = {
  listarRecomendacoes,
  contarRecomendacoes,
  marcarEmPedido,
  marcarIgnorado,
  reabrir,
  obterConfig,
  atualizarConfig,
  executarAgora,
  obterEngineStatus,
  SEVERIDADE_INFO,
  STATUS_INFO,
  ABC_INFO,
};

export default recomendacaoService;
